import { z } from 'zod'

import { isValidEmail } from '../../../../../../../../../utils'

const contactPersonFormSchema = z.object({
  email: z.string().refine((value) => !value || isValidEmail(value)),
  firstName: z.string().min(1),
  isPrimary: z.boolean(),
  lastName: z.string(),
})

export type ContactPersonFormValues = z.infer<typeof contactPersonFormSchema>
export type ContactPersonFormSchema = typeof contactPersonFormSchema

export const getContactPersonFormSchema = (): ContactPersonFormSchema => contactPersonFormSchema

export const parseContactPersonName = (name?: string): { firstName: string; lastName: string } => {
  if (!name) {
    return { firstName: '', lastName: '' }
  }

  const spaceIndex = name.indexOf(' ')

  if (spaceIndex === -1) {
    return { firstName: name, lastName: '' }
  }

  return { firstName: name.slice(0, spaceIndex), lastName: name.slice(spaceIndex + 1) }
}
